'use client';

import { useTranslations } from 'next-intl';
import { CacheKeys, ServerActionName } from '@headless-workspace/config';
import { AsyncData, ResultEmpty, ResultFailure, ResultSuccess } from '@headless-workspace/core-domain';
import { getRecommendedProductsServerAction, RecommendedProductsValue } from '../../../../server';
import { useSafeSWR } from '../../hooks';

const BASKET_RECOMMENDED_PRODUCTS_DEFAULT_ERROR = 'RECOMMENDED_PRODUCTS_ERROR';

type UseProductRecommendationsReturnType = AsyncData<RecommendedProductsValue>;

export const useBasketModalRecommendedProducts = (productId: string): UseProductRecommendationsReturnType => {
    const t = useTranslations('Discover.Pdp.information.basket.modal');
    const { data, isLoading, error } = useSafeSWR(
        CacheKeys.ProductRecommendations,
        ServerActionName.getProductRecommendations,
        () => getRecommendedProductsServerAction({ pageType: 'popUpBasket', productId }),
    );

    if (!data) {
        if (error) {
            return {
                isLoading,
                result: ResultFailure(
                    BASKET_RECOMMENDED_PRODUCTS_DEFAULT_ERROR,
                    error instanceof Error ? error.message : t('error.productRecommendations'),
                ),
            };
        }

        return { isLoading, result: ResultEmpty() };
    }

    if (data.type === 'empty' || data.data.length === 0) {
        return { isLoading, result: ResultEmpty() };
    }

    return { isLoading, result: ResultSuccess(data.data[0]) };
};
